export enum Mode {
  EPISODE = 'episode',
  SERIES = 'series',
  PLAYLIST = 'playlist',
}

export interface EpisodeDetails {
  /**
   * Content unique identifier.
   */
  itemId: string;

  /**
   * Numeric value indicating the bookmark position.
   */
  offset: number;

  /**
   * Season unique identifier of the content.
   */
  seasonId?: string;

  /**
   * Episode unique identifier of the content.
   */
  episodeId?: string;

  /**
   * Value indicating whether the content is an
   * episode or a series.
   */
  mode?: Mode;

  /**
   * Video unique identifier.
   */
  videoId?: string;

  /**
   * seasonNumber
   */
  seasonNumber?: number;

  /**
   * seasonNumber
   */
  episodeNumber?: number;

  /**
   * Type of content
   */
  contentType?: string;
}

export interface CustomBookmarkData {
  contentId?: string;
  seasonId?: string;
  episodeId?: string;
  mode?: Mode;
  videoId?: string;
  seasonNumber?: number;
  episodeNumber?: number;
  nextEpisodeDetails?: EpisodeDetails;
  contentType?: string;
}
